// Auth is tracked purely via localStorage keys (there is no context/provider).
// These helpers keep the "signed in?" check and the app-home path in one place so
// the landing page and the route guards in App.js stay in agreement.

// What a plain fetch() has to send to look like an axios call from this app: the
// bearer token and, for org-scoped routes, the active organization. Used by the agent
// event stream, which cannot go through axios because it reads a live body.
export function authHeaders() {
  const token = localStorage.getItem('admin_token');
  const orgId = localStorage.getItem('active_org_id');
  return {
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...(orgId ? { 'X-Org-Id': orgId } : {}),
  };
}

export function isSignedIn() {
  return !!localStorage.getItem('admin_token');
}

// Drop the stored session and send the browser to the sign-in page. The axios
// interceptor does this for an expired token on any normal call; the agent event
// stream is a raw fetch and never reaches that interceptor, so it calls this instead.
// Without it a long session that outlives its token leaves the user reading "sign in
// again" on a page with no way to do so.
export function signOut() {
  localStorage.removeItem('admin_token');
  localStorage.removeItem('admin_email');
  localStorage.removeItem('admin_name');
  window.location.href = '/login';
}

// Where the app "home" lives once signed in: admins land on the platform
// dashboard, everyone else on their own usage page.
export function dashboardPath() {
  return localStorage.getItem('admin_is_admin') === 'true' ? '/dashboard' : '/my-usage';
}
